import CustomBanner from './view';
export default CustomBanner;
